<template>
    <div>
        <b-card class="shadow mb-5 ml-md-5 mr-md-5 ml-0 mr-0">
            <div class="h2">Новые мероприятия по отлову в результате мониторинга</div>
            <small class="text-secondary" v-if="raid">{{ raid.objectLabel() }} по <b-link :to="{ name: 'requestsDetail', params: { id: requestId } }">заявке №{{ requestId }}</b-link></small>

            <b-row class="mt-4 mb-5" v-if="raid">
                <b-col >
                    <div class="h4 mb-3">1. Рейд</div>
                    <div class="col-12 p-0">
                        <catching-raid-detail :raid-data="raidData"/>
                    </div>
                </b-col>
            </b-row>

            <base-catching-bulk-create v-if="raid && request" :raid="raid" :is-completable="false" />
        </b-card>
    </div>
</template>

<script>
import CatchingRaidDetail from "@/pages/AppPages/Events/Catching/CatchingRaidDetail.vue";
import BaseCatchingBulkCreate from "@/pages/AppPages/Events/Catching/BaseCatchingBulkCreate.vue";
import api from "@/api";
import httpClient from "@/http";
import {Raid} from "@/pages/AppPages/Raids/raid";

export default {
    name: "RaidMonitoringBulkCreate",
    components: {BaseCatchingBulkCreate, CatchingRaidDetail},
    data() {
        return {
            raid: null,
            raidData: null
        }
    },
    computed: {
        raidId() {
            return parseInt(this.$route.params.raidId)
        },
        requestId() {
            if (this.raid) {
                return this.raid.request;
            }
            return null
        },
        request() {
            if (this.raid) {
                return this.raid.request;
            }
            return null
        },
    },
    methods: {
        fetchRaid() {
            const vm = this;
            return new Promise((resolve, reject) => {
                const requestUrl = api.raids.default.detail(vm.raidId);
                httpClient.get(requestUrl).then(response => {
                    vm.raidData = response.data;
                    vm.raid = new Raid();
                    vm.raid.applyData(vm.raidData);
                    resolve();
                }).catch(reason => {
                    vm.$bvToast.toast(reason, { title: 'Ошибка при получении информации о рейде с сервера', variant: 'danger'})
                    reject();
                });
            })
        },
    },
    mounted() {
        this.fetchRaid();
    }
}
</script>

<style scoped>

</style>